import React, { useState, useEffect } from 'react';

import { images } from 'assets';
import { OrderItemStatus } from 'constants/enums';
import { statusColor } from 'constants/arrays';
import { useAppSelector } from 'index';

interface OrderListStatusProps {
    orderId: string;
    showReady: boolean;
}

export default function OrdersListStatus(props: OrderListStatusProps) {
    const order = useAppSelector(
        (state) => state.orders.orders.find((order) => order.id === props.orderId)!
    );
    const orderDetails = useAppSelector((state) => state.orders.orderDetails);
    const [ready, setReady] = useState(false);
    const [color, setColor] = useState(statusColor[order?.status || 0]);

    function prepareStatusColor() {
        const targetOrder = orderDetails.id === props.orderId ? orderDetails : order;
        if (
            !targetOrder?.isPaid &&
            targetOrder?.orderItems?.every((item) => item.status === OrderItemStatus.Delivered)
        ) {
            return statusColor[9];
        } else {
            return statusColor[targetOrder?.status || 0];
        }
    }

    useEffect(() => {
        const delayRender = setTimeout(() => {
            setReady(props.showReady);
        }, 500);
        return () => clearTimeout(delayRender);
    }, [props.showReady]);

    useEffect(() => {
        setColor(prepareStatusColor());
    }, [order?.status]);

    return ready ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <img src={images.icons.triangleAtention} alt="triangle-atention" />
            <div
                style={{
                    width: 12,
                    height: 12,
                    borderRadius: 50,
                    backgroundColor: color,
                }}
            />
        </div>
    ) : (
        <div
            style={{
                width: 12,
                height: 12,
                borderRadius: 50,
                backgroundColor: color,
                marginLeft: '60%',
            }}
        />
    );
}
